import React from 'react';
import {NextSeo} from 'next-seo';
import SlideSpecialtyDetails from '@components/SpecialtyDetails/SlideSpecialtyDetails';
import SpecialtyDetailsNav from '@components/SpecialtyDetails/SpecialtyDetailsNav';
import SpecialtyDetails from '@components/SpecialtyDetails/SpecialtyDetails';
import SpecialtyDoctorList from '@components/SpecialtyDetails/SpecialtyDoctorList';
import SpecialtyServiceSection from '@components/SpecialtyDetails/SpecialtyServiceSection';
import InfrastructureCarousel from '@components/MedicalFacility/InfrastructureCarousel';
import SpecialtyCustomerComments from '@components/SpecialtyDetails/SpecialtyCustomerComments';
import FormRegisterSpecialty from '@components/SpecialtyDetails/FormRegisterSpecialty';
import {BookingProvider} from '@contexts/BookingContext';

/**
 * Trang chi tiết chuyên khoa
 * Hiển thị thông tin chi tiết về chuyên khoa, bác sĩ, dịch vụ và form đặt lịch
 */
export default function SpecialtyDetailsHome(props) {
    const { preloadedDepartment, hospitals = [], seoPage } = props;
    
    // Xử lý dữ liệu chuyên khoa (có thể là array hoặc object)
    const department = Array.isArray(preloadedDepartment) ? preloadedDepartment[0] : preloadedDepartment;

    return (
        <BookingProvider>
            {seoPage && <NextSeo {...seoPage} />}
            {/* Hero section với thông tin chuyên khoa */}
            <SlideSpecialtyDetails department={department} />

            {/* Navigation menu */}
            <SpecialtyDetailsNav department={department} />

            {/* Thông tin chi tiết chuyên khoa */}
            <SpecialtyDetails department={department} />

            {/* Danh sách bác sĩ */}
            <SpecialtyDoctorList preloadedDepartment={department} />

            {/* Dịch vụ y tế */}
            <SpecialtyServiceSection department={department} />

            {/* Hình ảnh cơ sở vật chất */}
            <InfrastructureCarousel department={department} />

            {/* Đánh giá của bệnh nhân */}
            <SpecialtyCustomerComments department={department} />

            {/* Form đặt lịch khám */}
            <FormRegisterSpecialty hospitals={hospitals} />
        </BookingProvider>
    );
}

SpecialtyDetailsHome.PageName = 'SPECIALTY-DETAILS';
